export const LOG_CANNON_PROD_API_KEY = import.meta.env
  .VITE_LOG_CANNON_PROD_API_KEY as string;
export const LOG_CANNON_NON_PROD_API_KEY = import.meta.env
  .VITE_LOG_CANNON_NON_PROD_API_KEY as string;
